import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const RegistryAccountConsult = () => {
  const navigate = useNavigate();
  const [cpfCnpjConsulta, setCpfCnpjConsulta] = useState("");
  const [showResults, setShowResults] = useState(false);
  
  const codigoRegistro = "CRPBan269";
  const dataRegistro = "29/09/2025";
  const statusTecnica = "Pendente de Complementações";
  const statusCompliance = "Aprovado";
  
  // Dados da conta (simulados)
  const contaData = {
    tipoConta: "Pessoa Jurídica",
    nomeCompleto: "Empresa Verde Ltda",
    cpfCnpj: "12.345.678/0001-90",
    email: "contato@empresaverde.com.br",
    telefone: "(11) 99999-9999",
    endereco: "Rua das Flores, 123 - Centro",
    estado: "SP",
    dataCadastro: "15/08/2024"
  };

  const handleConsult = () => {
    if (cpfCnpjConsulta.trim()) {
      setShowResults(true);
    }
  };

  return (
    <div className="space-y-6 max-w-6xl mx-auto p-6">
      {/* Cabeçalho */}
      <div className="flex items-center gap-4">
        <Button 
          variant="outline" 
          onClick={() => navigate('/admin/registry')}
          className="flex items-center gap-2"
        >
          <ArrowLeft size={18} />
          Voltar
        </Button>
        <h1 className="text-3xl font-bold text-gray-800">Consulta de Conta de Registro</h1>
      </div>

      {/* Campo de Busca */}
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Buscar Conta de Registro</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex gap-4 items-end">
            <div className="flex-1">
              <label htmlFor="cpfCnpj" className="block text-sm font-medium text-gray-700 mb-2">
                CPF/CNPJ
              </label>
              <Input
                id="cpfCnpj"
                value={cpfCnpjConsulta}
                onChange={(e) => setCpfCnpjConsulta(e.target.value)}
                placeholder="Digite o CPF ou CNPJ para consultar"
                className="w-full"
              />
            </div>
            <Button 
              onClick={handleConsult}
              className="bg-[#0e7cb4] text-white"
            >
              Consultar
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Dados da Conta - Aparece apenas após consulta */}
      {showResults && (
        <Card>
          <CardHeader>
            <CardTitle className="text-xl font-semibold">Dados da Conta</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Tipo de Conta
                </label>
                <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">
                  {contaData.tipoConta}
                </p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Nome Completo / Razão Social
                </label>
                <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">
                  {contaData.nomeCompleto}
                </p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  CPF/CNPJ
                </label>
                <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">
                  {contaData.cpfCnpj}
                </p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email
                </label>
                <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">
                  {contaData.email}
                </p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Telefone
                </label>
                <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">
                  {contaData.telefone}
                </p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Estado
                </label>
                <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">
                  {contaData.estado}
                </p>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Endereço
              </label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">
                {contaData.endereco}
              </p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Data de Cadastro
              </label>
              <p className="text-sm text-gray-900 bg-gray-50 p-2 rounded">
                {contaData.dataCadastro}
              </p>
            </div>
          </CardContent>
        </Card>
      )}

      {/* Status da Avaliação - Aparece apenas após consulta */}
      {showResults && (
        <Card>
        <CardHeader>
          <CardTitle className="text-xl font-semibold">Status da Avaliação</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex flex-col gap-1">
            <span className="text-sm">
              <strong>Código de Registro Preliminar:</strong> {codigoRegistro}
            </span>
            <span className="text-sm">
              <strong>Data de Registro Preliminar:</strong> {dataRegistro}
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Técnica */}
            <div>
              <h3 className="font-semibold text-lg mb-3">Técnica</h3>
              <div className="space-y-2">
                <label className="flex items-center">
                  <input 
                    type="radio" 
                    name="tecnica" 
                    checked={statusTecnica === 'Em análise'} 
                    readOnly 
                    className="mr-2"
                  />
                  Em análise
                </label>
                <label className="flex items-center">
                  <input 
                    type="radio" 
                    name="tecnica" 
                    checked={statusTecnica === 'Aprovado'} 
                    readOnly 
                    className="mr-2"
                  />
                  Aprovado
                </label>
                <label className="flex items-center">
                  <input 
                    type="radio" 
                    name="tecnica" 
                    checked={statusTecnica === 'Reprovado'} 
                    readOnly 
                    className="mr-2"
                  />
                  Reprovado
                </label>
                <label className="flex items-center">
                  <input 
                    type="radio" 
                    name="tecnica" 
                    checked={statusTecnica === 'Pendente de Complementações'} 
                    readOnly 
                    className="mr-2"
                  />
                  Pendente de Complementações
                </label>
              </div>
              <div className="mt-2 text-sm">
                <strong>Observações:</strong>{" "}
                <span className="text-red-600 underline cursor-pointer">
                  Falta detalhes da Metodologia
                </span>
              </div>
            </div>

            {/* Compliance */}
            <div>
              <h3 className="font-semibold text-lg mb-3">Conformidade</h3>
              <div className="space-y-2">
                <label className="flex items-center">
                  <input 
                    type="radio" 
                    name="compliance" 
                    checked={statusCompliance === 'Em análise'} 
                    readOnly 
                    className="mr-2"
                  />
                  Em análise
                </label>
                <label className="flex items-center">
                  <input 
                    type="radio" 
                    name="compliance" 
                    checked={statusCompliance === 'Aprovado'} 
                    readOnly 
                    className="mr-2"
                  />
                  Aprovado
                </label>
                <label className="flex items-center">
                  <input 
                    type="radio" 
                    name="compliance" 
                    checked={statusCompliance === 'Reprovado'} 
                    readOnly 
                    className="mr-2"
                  />
                  Reprovado
                </label>
                <label className="flex items-center">
                  <input 
                    type="radio" 
                    name="compliance" 
                    checked={statusCompliance === 'Pendente de Complementações'} 
                    readOnly 
                    className="mr-2"
                  />
                  Pendente de Complementações
                </label>
              </div>
              <div className="mt-2 text-sm">
                <strong>Observações:</strong>{" "}
                <span className="text-red-600 underline cursor-pointer">
                  Toda documentação entregue
                </span>
              </div>
            </div>
          </div>
        </CardContent>
        </Card>
      )}
    </div>
  );
};

export default RegistryAccountConsult;
